import { useCallback } from 'react';
import { updateOrganization } from '../../api/remiApi';

interface UpdateOrganizationBrandingData {
  org_name?: string;
  brokerage_name?: string;
  combined_name?: string;
  branding?: {
    primaryColor: string;
    secondaryColor: string;
  };
  org_links?: Record<string, string>;
  logoUrl?: string;
  subdomain?: string;
}

interface UseUpdateOrganizationBrandingReturn {
  updateBranding: (organizationId: string, data: UpdateOrganizationBrandingData) => Promise<void>;
}

export const useUpdateOrganizationBranding = (): UseUpdateOrganizationBrandingReturn => {
  const updateBranding = useCallback(
    async (organizationId: string, data: UpdateOrganizationBrandingData) => {
      try {
        await updateOrganization(organizationId, data as Record<string, unknown>);
      } catch (error) {
        console.error('Error updating organization branding:', error);
        throw error;
      }
    },
    []
  );

  return { updateBranding };
};
